var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "time_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.95 11.93c0 5.54 4.51 10.05 10.05 10.05s10.05-4.51 10.05-10.05S17.54 1.88 12 1.88 1.95 6.39 1.95 11.93m2 0c0-4.44 3.61-8.05 8.05-8.05s8.05 3.61 8.05 8.05-3.61 8.05-8.05 8.05-8.05-3.61-8.05-8.05m10.34 3.69c.2.19.46.29.71.29.26 0 .51-.1.71-.3a.996.996 0 0 0 0-1.41L13 11.51v-4.6c0-.55-.45-1-1-1s-1 .45-1 1v5.02c0 .27.1.52.29.71z",
  clipRule: "evenodd"
})));
export default SvgTime;